import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [state, setState] = useState({ loading: true, paid: false, msg: "" });

    useEffect(() => {
        let tries = 0;
        const poll = async () => {
            try {
                const res = await api.get(`/payments/status/${sessionId}`);
                if (res.data.payment_status === "paid") {
                    setState({ loading: false, paid: true, msg: "Booth confirmed!" });
                    return;
                }
                if (res.data.status === "expired") {
                    setState({ loading: false, paid: false, msg: "Session expired" });
                    return;
                }
                if (tries++ < 6) setTimeout(poll, 1800);
                else setState({ loading: false, paid: false, msg: `Payment status: ${res.data.payment_status || "pending"}` });
            } catch (err) {
                setState({ loading: false, paid: false, msg: err?.response?.data?.detail || "Could not verify" });
            }
        };
        if (sessionId) poll();
        else setState({ loading: false, paid: false, msg: "Missing session" });
    }, [sessionId]);

    return (
        <Shell>
            <div className="max-w-xl mx-auto px-6 py-24 text-center">
                {state.loading ? (
                    <>
                        <Loader2 className="mx-auto animate-spin text-brand-forest" size={42} />
                        <h2 className="font-heading text-2xl font-extrabold mt-4">Confirming your booth…</h2>
                    </>
                ) : state.paid ? (
                    <>
                        <CheckCircle2 className="mx-auto text-emerald-500" size={56} />
                        <h2 className="font-heading text-3xl font-extrabold mt-4">You're in!</h2>
                        <p className="text-brand-mute mt-2">Your booth is confirmed. The host has been notified.</p>
                        <Link to="/vendor" data-testid="back-to-dash" className="pill btn-coral inline-flex items-center gap-2 mt-8 px-6 py-3 font-semibold">Back to dashboard</Link>
                    </>
                ) : (
                    <>
                        <h2 className="font-heading text-2xl font-extrabold mt-4">{state.msg}</h2>
                        <Link to="/vendor" className="pill btn-coral inline-flex items-center gap-2 mt-8 px-6 py-3 font-semibold">Back to dashboard</Link>
                    </>
                )}
            </div>
        </Shell>
    );
}
